import { SVGProps } from 'react';

const RightChevron = ({
  width = '24px',
  height = '24px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    id='ic-chevron-right'
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 24 24'
    {...props}
  >
    <g id='Layer' transform='translate(8.856 6.248)'>
      <g id='Vrstva_128' data-name='Vrstva 128'>
        <path
          id='Path_129'
          data-name='Path 129'
          d='M9.11,16.1a1,1,0,0,0,1.51,1.32l4.22-4.85a1.21,1.21,0,0,0,0-1.62l-4.19-4.4A1,1,0,1,0,9.24,7.97l3.53,3.71a.25.25,0,0,1,0,.33Z'
          transform='translate(-8.862 -6.259)'
        />
      </g>
    </g>
  </svg>
);

export default RightChevron;
